import 'twin.macro';

const SecondaryButton = ({ text, handleClick, otherStyle, ...rest }) => {
  return (
    <button
      tw="bg-white border-[1px] border-[#BDC4C9] px-6 py-[7px] transition-all duration-500 rounded-[4px] text-sm font-bold"
      onClick={handleClick}
      css={otherStyle}
      className="secondary-button"
      {...rest}
    >
      {text}
    </button>
  );
};
export default SecondaryButton;
